function loadImage(src): Promise<string> {
  return new Promise((resolve, reject) => {
    const image = new Image();

    image.onload = () => resolve(src);
    image.onerror = (error) => reject(error);
    image.src = src;
  });
}

export default loadImage;
